export default __webpack_public_path__ + "static/media/cross.1d62ebc0.svg";